import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.function.name.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useCallbackRef from 'hooks/useCallbackRef';
import { CONTENT_TYPES } from 'utils/asset/constants';
import { validateZipFiles } from './utils';
import Modal from 'components/Modal';
import Card from 'components/Card';
import Panel from 'components/Panel';
import TextLink from 'components/TextLink';
import ModalHeadline from 'components/ModalHeadline';
import Landmark from 'components/Landmark';
import { PlainZipFileModal } from 'components/UploadFileModals';
import FileUploader from './FileUploader';
var NewFileModal = function NewFileModal(_ref) {
  var isLoading = _ref.isLoading,
    onUploadAsset = _ref.onUploadAsset,
    onSelectAsset = _ref.onSelectAsset,
    closeNewFileModal = _ref.onClose,
    showSelectAsset = _ref.showSelectAsset;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    file = _useState2[0],
    setFile = _useState2[1];
  var _useState3 = useState(CONTENT_TYPES.UPLOAD),
    _useState4 = _slicedToArray(_useState3, 2),
    type = _useState4[0],
    setType = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isCheckingFile = _useState6[0],
    setIsCheckingFile = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isZipModalOpen = _useState8[0],
    setIsZipModalOpen = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isPlainZipOk = _useState10[0],
    setIsPlainZipOk = _useState10[1];
  var titleId = 'add-new-file-modal';
  var uploadAsset = function uploadAsset(_ref2) {
    var file = _ref2.file,
      type = _ref2.type;
    onUploadAsset({
      file: file,
      type: type
    });
    setIsCheckingFile(false);
  };
  var handleUpload = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
      var file, fileType, data, scormOrMicrositeType;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            file = _ref3.file;
            setIsCheckingFile(true);
            setFile(file);
            fileType = type; // Check if file is a zip file
            // If yes, check if file is microsite, scorm or plain zip
            _context.next = 6;
            return validateZipFiles(file);
          case 6:
            data = _context.sent;
            if (!(data !== null && data !== void 0 && data.isScormOrMicrositeZip)) {
              _context.next = 13;
              break;
            }
            scormOrMicrositeType = data.isScorm ? CONTENT_TYPES.SCORM : CONTENT_TYPES.MICROSITE;
            fileType = scormOrMicrositeType;
            setType(scormOrMicrositeType);
            _context.next = 16;
            break;
          case 13:
            if (!(data !== null && data !== void 0 && data.isZip)) {
              _context.next = 16;
              break;
            }
            setIsZipModalOpen(true);
            return _context.abrupt("return");
          case 16:
            // For all files, which aren't plain zip files, commence with file upload as normal
            uploadAsset({
              file: file,
              type: fileType
            });
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleUpload(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var uploadZipRef = useCallbackRef(function () {
    // If we received user confirmation to use plain zip file type in case of plain zip upload,
    // proceed with upload of file
    uploadAsset({
      file: file,
      type: type
    });
  });
  useEffect(function () {
    if (isPlainZipOk) {
      uploadZipRef.current();
    }
  }, [isPlainZipOk, uploadZipRef]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    id: "add-new-file-modal",
    "aria-labelledby": titleId,
    onRequestClose: closeNewFileModal
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "raised"
  }, /*#__PURE__*/React.createElement(ModalHeadline, {
    title: t('actions_upload_a_file'),
    titleId: titleId,
    onClose: closeNewFileModal
  }), isCheckingFile || isLoading ? /*#__PURE__*/React.createElement(Landmark, {
    icon: "spinner",
    height: 220
  }, t('modal_upload_file_loading')) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(FileUploader, {
    onSelect: handleUpload
  })), showSelectAsset && /*#__PURE__*/React.createElement(Panel, {
    align: "center"
  }, /*#__PURE__*/React.createElement(TextLink, {
    bold: true,
    as: "button",
    onClick: onSelectAsset
  }, t('modal_upload_file_select_asset_message')))))), isZipModalOpen && /*#__PURE__*/React.createElement(PlainZipFileModal, {
    fileName: file === null || file === void 0 ? void 0 : file.name,
    onConfirm: function onConfirm() {
      return setIsPlainZipOk(true);
    },
    onCancel: function onCancel() {
      setIsCheckingFile(false);
      setIsZipModalOpen(false);
    }
  }));
};
export default NewFileModal;